import React, { ButtonHTMLAttributes } from 'react';

interface ButtonProps extends ButtonHTMLAttributes<HTMLButtonElement> {
  children: React.ReactNode;
  className?: string;
  variant?: 'primary' | 'secondary' | 'warning' | 'success' | 'danger';
  size?: 'small' | 'medium' | 'large';
  fullWidth?: boolean;
}

const Button: React.FC<ButtonProps> = ({
  children,
  className = '',
  variant = 'primary',
  size = 'medium',
  fullWidth = false,
  onClick,
  ...props
}) => {
  const baseClass = 'idsk-button';
  const variantClass = variant ? `${baseClass}--${variant}` : '';
  const sizeClass = size ? `${baseClass}--${size}` : '';
  const widthClass = fullWidth ? `${baseClass}--full-width` : '';

  const combinedClassName = `${baseClass} ${variantClass} ${sizeClass} ${widthClass} ${className}`.trim();

  return (
    <button
      className={combinedClassName}
      onClick={onClick}
      {...props}
    >
      {children}
    </button>
  );
};

export default Button;
